import script from "./OperationsMonitoring.vue?vue&type=script&setup=true&lang=js"
export * from "./OperationsMonitoring.vue?vue&type=script&setup=true&lang=js"

import "./OperationsMonitoring.vue?vue&type=style&index=0&id=147223fd&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-147223fd"]])

export default __exports__